import navbarLogo from '@/assets/themes/aham37/navbar-logo.svg';
import chatAvatar from '@/assets/themes/aham37/chat-avatar.svg';
import favicon from '@/assets/themes/aham37/favicon.ico';
import type { ThemeDefinition } from '../types';

export const aham37Theme: ThemeDefinition = {
  id: 'aham37',
  name: 'AHAM37',
  pageTitle: 'AHAM37 Platform',
  assets: {
    navbarLogo,
    fullLogo: navbarLogo, // dark version — visible on white backgrounds
    chatAvatar,
    favicon,
    clerkLogoUrl: 'https://assets.apps.strivelabs.co/public-assets/aham37-black.svg',
  },
};
